import { IImportFileInjectable } from '@src/slide/application/service/import-file-manager/core/import-file-manager.interface';
import UploadTool from '@src/slide/application/service/import-file-manager/core/slide-upload/slide-upload';

export class ImportFileInjectable implements IImportFileInjectable {
    public async getUploadToolImpl(): Promise<UploadTool | undefined> {
        return undefined;
    }
}
